import {Component, Input} from "@angular/core";

@Component({
  selector: "admin-page-tab-section",
  templateUrl: "./tab-section.component.html",
  styleUrls: ["./tab-section.component.css"]
})
export class TabSectionComponent {

  @Input() title: string = "";

}
